import { TestGraph } from "../../../types";
import { graphConfig } from "./config";
import { GraphSize } from "./index";

type Props = {
    size: GraphSize;
    graphData: TestGraph;
};

const GraphRightSideTitles = ({ size, graphData }: Props) => {
    if (!graphData.response2_y_label) return null;

    return (
        <div
            style={{
                position: "absolute",
                top: graphConfig.position[size].top,
                bottom: graphConfig.position[size].bottom,
                right: size === "sm" ? "6px" : "12px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                whiteSpace: "nowrap",
            }}
            className={graphConfig.size[size].texts.className}
        >
            <div className={`relative rotate-[90deg] flex items-center gap-2.5`}>
                <div
                    style={{
                        borderRadius: "100%",
                        left: graphConfig.dot[size].left,
                        width: graphConfig.dot[size].size,
                        height: graphConfig.dot[size].size,
                        backgroundColor: graphData.response2_label_color,
                    }}
                />
                {graphData.response2_y_label}
            </div>
        </div>
    );
};

export default GraphRightSideTitles;
